<div class="col mb-3">
  <div class="header">
    {{ header }} <span *ngIf="keyRequired" >*</span>
  </div>

  <div class="btn-group w-100 " ngbDropdown (openChange)="onDropdownOpenChange($event)" style="position: relative;">
    <div class="input-group">
      <input
        ngbDropdownToggle
        type="text"
        class="form-control w-100"
        [ngClass]="{'error-border': showRequiredError, 'has-left-icon': hasIcon}"
        [(ngModel)]="searchTerm"
        [placeholder]="placeholder"
        (input)="onInputChange($event)"
        (click)="($event.stopPropagation())"
      />
      <i class="fa fa-angle-down"></i>
      <span class="select-icon-left" *ngIf="hasIcon">
        <i [ngClass]="resolvedIconClass"></i>
      </span>
    </div>

    <ul ngbDropdownMenu class="dropdown-menu w-100">
      <div class="scroll" style="overflow-y: auto; max-height: 250px;">
        <li *ngIf="!internalOptions.length"
            class="dropdownItems text-muted px-2 py-1"
            style="border: none;">
          No items available
        </li>

        <li *ngFor="let item of filteredItems"
            ngbDropdownItem
            style="border: none; cursor: pointer;"
            class="dropdownItems"
            (click)="selectOption(item)">
          {{ item.name }}
        </li>
      </div>
    </ul>

  </div>

  <div *ngIf="showRequiredError" class="text-danger">
    This field is required
  </div>
</div>
